// =====================================================================
// MrResurface.com — captured content archive (from live site, Sept 2026)
// All copy, media paths, SEO titles/descriptions and structure below were
// captured from the live Townsquare-hosted mrresurface.com before shutdown.
// Media is self-hosted under /media/ (public/media).
// =====================================================================

const M = "/media";

export const business = {
  name: "Mr. Resurface LLC",
  shortName: "MrResurface",
  owner: "Ernest Staton Jr.",
  since: 1996,
  logo: `${M}/logo4.png`,
  favicon: `${M}/favicon.png`,
  phone: "(203) 578-5260",
  phoneRaw: "+12035785260",
  phoneDigits: "2035785260",
  email: "mrresurface@gmail.com",
  address: {
    line1: "1776 Meriden Rd.",
    line2: "Unit 1B - Rear Building",
    city: "Wolcott",
    state: "CT",
    zip: "06716",
  },
  directionsUrl:
    "https://maps.google.com/maps?daddr=1776%20Meriden%20Rd.,%20Wolcott,%20CT%2006716&hl=en",
  hours: [
    { day: "Mon", value: "9:00AM-5:00PM" },
    { day: "Tue", value: "9:00AM-5:00PM" },
    { day: "Wed", value: "9:00AM-5:00PM" },
    { day: "Thu", value: "9:00AM-5:00PM" },
    { day: "Fri", value: "9:00AM-5:00PM" },
    { day: "Sat", value: "Closed" },
    { day: "Sun", value: "Closed" },
  ],
  copyright: "Copyright © 2026 Mr. Resurface, all rights reserved.",
  serviceArea:
    "Based in Wolcott / Waterbury, CT — within a 40 minute drive of most of Connecticut, reaching Hartford, New Haven, Fairfield, Middlesex, Litchfield and Tolland counties via I-84, I-91 and Route 8.",
};

export const social = [
  { label: "Facebook", icon: "facebook", url: "http://www.facebook.com/MrResurfaceLLC/" },
  { label: "Twitter", icon: "twitter", url: "http://www.twitter.com/MrResurfaceCT" },
  {
    label: "BBB",
    icon: "bbb",
    url: "https://www.bbb.org/us/ct/waterbury/profile/bathtub-refinishing/mr-resurface-llc-0111-1003783#sealclick",
  },
  {
    label: "Angie's List",
    icon: "angi",
    url: "https://www.angi.com/companylist/us/ct/wolcott/mr-resurface-llc-reviews-315262.htm",
  },
];

export const googleReviewUrl =
  "https://www.google.com/search?hl=en&q=Mr.+Resurface+LLC&ludocid=17987504234654941231#lrd=0x89e7c72b968f9bf5:0xf9a073ccae71402f,3";

// --- Navigation ----------------------------------------------------------
// Simplified six-item primary menu. "Make a Payment" is deliberately kept out
// of this array and rendered as a standalone CTA (see navCta).
export const nav = [
  { label: "Home", to: "/" },
  {
    label: "Services",
    to: "#",
    children: [
      { label: "Bathtub Refinishing", to: "/tub-refinishing" },
      { label: "Wall Tile Refinishing", to: "/wall-tile-refinishing" },
      { label: "Kitchen Countertops", to: "/countertops" },
      { label: "Color Choices", to: "/color-choices" },
    ],
  },
  {
    label: "About",
    to: "/about-us",
    children: [
      { label: "About Mr. Resurface", to: "/about-us" },
      { label: "History & Experience", to: "/our-history-and-experience" },
      { label: "Showroom", to: "/showroom" },
    ],
  },
  { label: "Reviews", to: "/testimonials" },
  {
    label: "FAQs",
    to: "#",
    children: [
      { label: "Bathtub & Tile FAQ", to: "/tub-tile-faq" },
      { label: "Countertops FAQ", to: "/countertops-faq" },
    ],
  },
  { label: "Contact / Free Estimate", to: "/contact-us" },
];

// Standalone, visually distinct navigation action.
export const navCta = { label: "Make a Payment", to: "/make-a-payment" };

// Four priority links shown directly in the white header (lg and up).
// They also remain inside the full Menu; routes are reused, no new pages.
export const priorityNav = [
  { label: "Bathtub Refinishing", to: "/tub-refinishing" },
  { label: "Wall Tile Refinishing", to: "/wall-tile-refinishing" },
  { label: "Reviews", to: "/testimonials" },
  {
    label: "FAQs",
    to: "#",
    children: [
      { label: "Bathtub & Tile FAQ", to: "/tub-tile-faq" },
      { label: "Countertops FAQ", to: "/countertops-faq" },
    ],
  },
];

// Secondary links that live in the footer only (no nav duplication).
export const footerLinks = [
  { label: "Make a Payment", to: "/make-a-payment" },
  { label: "Billing Terms", to: "/billing" },
  { label: "Write a Review", href: googleReviewUrl },
];

// --- SEO captured from live <title> / meta description -------------------
export const seo = {
  "/": {
    title: "Mr. Resurface | Bathtub & Countertop Refinishing in Connecticut",
    description:
      "Professional bathtub, countertop, tile and surface refinishing serving Connecticut. Restore your surfaces without the cost of replacement.",
  },
  "/about-us": {
    title: "About Us: Connecticut: Mr. Resurface",
    description:
      "Meet Mr. Resurface of Wolcott, CT — a family-run, BBB-accredited refinishing company restoring bathtubs, wall tile and countertops across Connecticut since 1989.",
  },
  "/our-history-and-experience": {
    title: "Our History and Experience: Connecticut: Mr. Resurface",
    description:
      "Three decades of hands-on bathtub, tile and countertop refinishing experience throughout Connecticut. See how Mr. Resurface built its reputation one job at a time.",
  },
  "/tub-refinishing": {
    title: "Bathtub Refinishing: Wolcott, Connecticut: Mr. Resurface",
    description:
      "Call today to get started or text a picture of your bathtub for a free estimate on your bathtub resurfacing project. Ask about our bathroom countertop resurfacing services!",
  },
  "/wall-tile-refinishing": {
    title: "Wall Tile Refinishing: Wolcott, Connecticut: Mr. Resurface",
    description:
      "Has the tile in your bathroom become outdated or lost its appeal? Let MrResurface update your wall tiles with thorough refinishing services. 203-578-5260",
  },
  "/countertops": {
    title: "Kitchen & Bathroom Countertops: Connecticut: Mr. Resurface",
    description:
      "Restore or update the countertops in your kitchen by contacting MrResurface in Wolcott, CT today! Text pictures of your countertops to 203-578-5260 and get a free estimate.",
  },
  "/color-choices": {
    title: "Color Choices: Connecticut: Mr. Resurface",
    description:
      "Browse the bathtub, wall tile and countertop finish colours available from Mr. Resurface, including solid colours and multi-colour stone-look finishes.",
  },
  "/tub-tile-faq": {
    title: "Bath Tub & Tile FAQ: Connecticut: Mr. Resurface",
    description:
      "Answers to the most common bathtub and wall tile refinishing questions — how long it lasts, curing time, cleaning, durability and what to expect on the day.",
  },
  "/countertops-faq": {
    title: "Countertops FAQ: Connecticut: Mr. Resurface",
    description:
      "Countertop refinishing questions answered by Mr. Resurface: suitable surfaces, durability, heat resistance, care instructions and how long the work takes.",
  },
  "/showroom": {
    title: "Showroom: Connecticut: Mr. Resurface",
    description:
      "See real before-and-after photos of bathtub, wall tile and countertop refinishing projects completed by Mr. Resurface across Connecticut.",
  },
  "/testimonials": {
    title: "Testimonials: Connecticut: Mr. Resurface",
    description:
      "Read verified Google, Angi and Facebook reviews plus customer testimonials for Mr. Resurface bathtub, tile and countertop refinishing in Connecticut.",
  },
  "/contact-us": {
    title: "Contact Us: Wolcott, Connecticut: Mr. Resurface",
    description:
      "Request a free refinishing estimate from Mr. Resurface. Send photos of your bathtub, tile or countertops, or call (203) 578-5260 in Wolcott, Connecticut.",
  },
  "/billing": {
    title: "Billing: Connecticut: Mr. Resurface",
    description:
      "Mr. Resurface billing terms, accepted payment methods, deposits and invoice information for Connecticut refinishing customers.",
  },
  "/make-a-payment": {
    title: "Make a Payment: Connecticut: Mr. Resurface",
    description:
      "Pay your Mr. Resurface deposit, partial payment or remaining balance through our secure hosted checkout. Credit cards, Apple Pay and Google Pay accepted.",
  },
};

// --- Home page hero slider ---------------------------------------------
export const heroSlides = [
  {
    image: `${M}/White-Bathroom4-1024x764.jpg`,
    headline: "Re-glaze Your Bathtub and Bathroom Wall Tile",
    cta: "Send A Message Today",
    to: "/contact-us",
  },
  {
    image: `${M}/1624906619832_fjly.jpg`,
    headline: "Mr. Resurface Can Update the Tile in Your Bathroom",
    cta: "Send A Message Today",
    to: "/contact-us",
  },
  {
    image: `${M}/kitchen-countertop-resurfaced.png`,
    headline: "Resurface Your Home Kitchen Countertop",
    cta: "Send A Message Today",
    to: "/contact-us",
  },
];

export const reviewsBanner = {
  headline: "Read Reviews From Our Customers",
  cta: "Read Our Reviews",
  to: "/testimonials",
};

export const homeServices = [
  {
    title: "Tub Refinishing",
    to: "/tub-refinishing",
    image: `${M}/1589979985998_1.jpg`,
    desc: "Breathe life back into the bathtubs throughout your Waterbury home. Consider partnering with us on your next bathtub refinishing project.",
  },
  {
    title: "Wall Tile Refinishing",
    to: "/wall-tile-refinishing",
    image: `${M}/1621954273885_20_2.jpg`,
    desc: "If the wall tile in your bathroom or kitchen is starting to look dingy, consult the wall tile refinishing experts in Wolcott, CT at MrResurface for restoration.",
  },
  {
    title: "Kitchen Countertop Resurfacing",
    to: "/countertops",
    image: `${M}/1589923096443_fature.jpg`,
    desc: "Update the countertops in your kitchen and transform their overall look and feel. We offer some of the most competitive prices available in Waterbury, CT.",
  },
  {
    title: "Contact Us",
    to: "/contact-us",
    image: `${M}/f4.jpg`,
    desc: "Get started on your next project by contacting MrResurface today. Call or text a picture of the surface you need replaced and we'll provide you with a free estimate.",
  },
];

export const homeFeatures = [
  {
    image: `${M}/a1.jpg`,
    headline: "Update Your Bathtub Surfaces and Revive Your Space",
    subhead:
      "PROFESSIONAL BATHTUB REFINISHING SERVICES IN THE GREATER WOLCOTT, CT AREA",
    paragraphs: [
      "Do you have a beautiful cast iron tub, but it's just the wrong color? Does the color of your one-piece fiberglass unit simply not fit with your idea of a modern bathroom? Has your tub gotten hard to clean? Instead of spending $2500 or more to replace your tub with a lower quality steel tub or a flimsy multi-section fiberglass tub with seams, why not re-glaze your existing tub and save time and money?",
      "When you begin to notice signs of wear and tear on your bathtub, consult the expert at MrResurface in Wolcott, CT. We offer professional bathtub refinishing services that are customized to meet your needs.",
      "Count on our owner and operator, Ernest Staton Jr., to treat your home and bathroom with the same care and attention to detail that he would treat his own.",
      "Text a picture of your bathtub to 203-578-5260 for a free estimate on your bathtub resurfacing project.",
    ],
    bullets: [],
  },
  {
    image: `${M}/Screenshot_2.jpg`,
    headline: "MAKE YOUR TUB LOOK BRAND NEW AGAIN!",
    subhead: "Experience and quality you can trust",
    paragraphs: [
      "If you're ready to get rid of your outdated blue bathtub surface or you want to return your bathtub's surface to its original condition, rely on our 20+ years of experience to get the job done. We specialize in getting your standard or antique household bathtubs refinished to perfection.",
      "Over the years, the finish and shine on your tub will naturally diminish. Whether you have an antique tub with claw feet or standard tub that is just the wrong color or you just moved into a home that could use a little TLC on the tub, call MrResurface. Ernest will take your tub and make it look brand new again with our refinishing and resurfacing services. As a homeowner, you can benefit from our refinishing services by calling us for:",
    ],
    bullets: [
      { label: "Standard bathtub resurfacing", to: "/tub-refinishing" },
      { label: "Fiberglass/tub-shower refinishing", to: "/tub-refinishing" },
      { label: "Wall tile refinishing", to: "/wall-tile-refinishing" },
    ],
  },
];

export const badges = {
  reviewUs: `${M}/review-us-button-4-small.png`,
  googleStars: `${M}/Screenshot_4.png`,
  facebookBtn: `${M}/Follow-us-on-Facebook-Button-PNG-03045-540X202.png`,
  twitter: `${M}/twitter.gif`,
  angiesList: `${M}/angies-list.png`,
  bbbHorz: `${M}/cbbb-badge-horz.png`,
  bbbSeal:
    "https://seal-ct.bbb.org/seals/blue-seal-187-130-mrresurfacellc-1003783.png",
};

// --- Interior pages -----------------------------------------------------
export const aboutPage = {
  h1: "About Refinishing",
  hero: `${M}/fjly.jpg`,
  paragraphs: [
    "We specialize in kitchen countertop resurfacing and bathtub and wall tile reglazing. Our kitchen countertop resurfacing process is a state of the art, man-made composite that we apply right over your existing laminate/formica countertop in a liquid form, eliminating the need to remove your existing countertops. We use your existing kitchen countertop as the template and base for your newly-resurfaced countertops, cutting down on waste and labor as we are recycling your current countertop and applying a durable, hard composite finish over your old kitchen countertops.",
    "Your resurfaced kitchen countertop will have the look of a speckled corian, marble or slate stone granite. We also offer custom edging for your Kitchen countertop to truly set it apart from a laminate look and give it the look of a solid surface countertop.",
    "Our tub and wall tile resurfacing (refinishing) service is an easy way to renew your bathroom without breaking the bank. We use the highest quality acrylic urethane to reglaze your tub and tile. We don't use the less expensive epoxy that some reglazers are still using, as such a material does not last. Our A+ record with the BBB is proof that we know what we're doing and that we'll go the extra mile to keep our customers satisfied.",
  ],
};

export const historyPage = {
  h1: "Owner History and Experience",
  hero: `${M}/Tub-before-after53.jpg`,
  paragraphs: [
    "Ernest Staton, Jr., the founder of MrResurface LLC, has been reglazing bathtubs and resurfacing kitchen countertops since 1996. Ernest started his resurfacing career by reglazing bathtubs, then branched off by offering the additional service of countertop resurfacing. He approached this new service after doing a remodel project at a Waterbury, CT place of worship and seeing how well the resurfaced countertops withstood daily use by hundreds of people.",
    "Thanks to the success and durability of the countertop resurfacing application, he started offering it to homeowners, along with custom edging choices and unique color patterns.",
    "The success of MrResurface LLC is largely due to the research and innovations that Ernest has put into advancing the resurfacing process, keeping MrResurface LLC ahead of the competition. Ernest has never been happy with the status quo of resurfacing and continues to integrate the latest available technology into his resurfacing process.",
    "MrResurface's A+ rating with the Better Business Bureau is evidence of Ernest's commitment to customer satisfaction. MrResurface LLC is an owner-run business. You can always reach Ernest by e-mail any time of the day, or call him at (203) 578-5260, Monday-Friday. MrResurface LLC serves most of Connecticut.",
  ],
};

export const tubPage = {
  h1: "Update Your Bathtub Surfaces and Revive Your Space",
  hero: `${M}/2.jpg`,
  sections: [
    {
      subhead: "Professional bathtub refinishing services in the greater Wolcott, CT area",
      paragraphs: [
        "Do you have a beautiful cast iron tub, but it's just the wrong color? Does the color of your one-piece fiberglass unit simply not fit with your idea of a modern bathroom? Has your tub gotten hard to clean? Instead of spending $2500 or more to replace your tub with a lower quality steel tub or a flimsy multi-section fiberglass tub with seams, why not re-glaze your existing tub and save time and money?",
        "When you begin to notice signs of wear and tear on your bathtub, consult the expert at MrResurface in Wolcott, CT. We offer professional bathtub refinishing services that are customized to meet your needs.",
        "Count on our owner and operator, Ernest Staton Jr., to treat your home and bathroom with the same care and attention to detail that he would treat his own.",
        "Call today to get started or text a picture of your bathtub for a free estimate on your bathtub resurfacing project.",
      ],
    },
    {
      subhead: "Make your tub look brand new again!",
      paragraphs: [
        "If you're ready to get rid of your outdated blue bathtub surface or you want to return your bathtub's surface to its original condition, rely on our 20+ years of experience to get the job done. Our team specializes in getting your standard or antique household bathtubs refinished to perfection.",
        "Over the years, the finish and shine on your tub will naturally diminish. Whether you have an antique tub with claw feet or you just moved into a home could use a little TLC on the tub, call MrResurface. Our skilled professionals will take your tub and make it look brand new again with our refinishing and resurfacing services. As a homeowner, you can benefit from our bathroom refinishing services by calling us for standard bathtub resurfacing.",
        "Get your bathroom sparkling again. Contact MrResurface of Wolcott, CT by calling 203-578-5260.",
      ],
    },
  ],
  video: { id: "IK-d6Hbafac", title: "MrResurface Bathtub and Tile Reglazing Video.wmv" },
  gallery: [
    "dhhhhkjh.jpg",
    "tub_before1.jpg",
    "kjvl.jpg",
    "1623965510990_khlul.jpg",
    "b1.jpg",
    "b22.jpg",
    "a1.jpg",
    "a2.jpg",
    "2.jpg",
    "1_1.jpg",
    "20-2.jpg",
    "a-before.jpg",
    "a-after.jpg",
    "b-after.jpg",
    "b-before.jpg",
    "c-before.jpg",
    "c-after.jpg",
    "d-before.jpg",
    "d-after.jpg",
    "green-bathroom-300x224.jpg",
    "whiteback-counter-tile-1024x764.jpg",
    "Grey-bathroom22-150x150.jpg",
    "whitebathroom2-1024x7641.jpg",
    "Grey-Bathroom6-224x3001.jpg",
    "White-Bathroom4-1024x7641.jpg",
    "workpics-005.jpg",
    "workpics-008-1024x764.jpg",
  ].map((f) => `${M}/${f}`),
};

export const wallTilePage = {
  h1: "Wall Tile Refinishing",
  hero: `${M}/Bathtubs_New.jpg`,
  heroHeadline: "Shower Wall Tiles Need TLC Too",
  sections: [
    {
      subhead: "Wall tile refinishing services in the greater Wolcott, CT area",
      paragraphs: [
        "Has the tile in your bathroom become outdated or lost its appeal? Is your tile color outdated and in need of a change? Don't waste your time attempting to replace your wall tile or spending thousands of dollars to replace it when you can have it re-glazed. Let MrResurface update your wall tiles with thorough refinishing services.",
        "Thanks to over 20 years of industry experience, our owner and operator, Ernest Staton Jr., has the skills, equipment and materials necessary to professionally resurface the tile throughout your home. He works on every project himself, ensuring the highest quality service and your satisfaction.",
        "If you want to re-glaze your tile with a neutral color to get a more modern bathroom, rely on Ernest to get the job done right the first time. Call or text 203-578-5260 today to get in touch with MrResurface in Wolcott, CT.",
      ],
    },
    {
      subhead: "Experience a transformative fix for your dated bathroom",
      paragraphs: [
        "If your shower wall tile seems to be lackluster and losing its shine, or the color is just outdated, you could benefit from wall tile refinishing. Replacing your shower wall tile can be extremely expensive, time-consuming and inconvenient for you and your family. At MrResurface, we understand how important your shower can be. Our team of professionals will reglaze your bathroom wall tiles leaving them clean, fresh, and modern.",
        "Don't wait any longer to update and enhance your bathroom by refinishing the wall tile. Call MrResurface in Wolcott, CT today at 203-578-5260 to get started.",
      ],
    },
  ],
  gallery: [
    "khljhl.jpg",
    "kjvl.jpg",
    "fjly.jpg",
    "ghjvl.jpg",
    "1623965652790_khlul.jpg",
    "gktuk.jpg",
    "Bathtubs_New.jpg",
    "20-21.jpg",
    "d-before1.jpg",
    "d-after1.jpg",
    "e-before.jpg",
    "e-after.jpg",
    "green-bathroom-300x2241.jpg",
    "whiteback-counter-tile-1024x7641.jpg",
    "Grey-bathroom22-150x1501.jpg",
    "whitebathroom2-1024x7641.jpg",
    "Grey-Bathroom6-224x300.jpg",
    "White-Bathroom4-1024x7641.jpg",
  ].map((f) => `${M}/${f}`),
};

export const countertopsPage = {
  h1: "Update the Countertops in Your Kitchen",
  hero: `${M}/Granite-edge13.jpg`,
  subhead: "Countertop resurfacing services in the Greater Wolcott, CT area",
  paragraphs: [
    "Do you have laminate/formica countertops in your kitchen, but want the look of a solid surface like granite or corian? MrResurface can transform your existing counter into a beautiful solid surface without having to remodel the whole kitchen. MrResurface can update your kitchen counters in a single day.",
    "For over 20 years, MrResurface has been providing expert kitchen countertop resurfacing services to residential clients in the Greater Wolcott, CT area. Choose from a wide variety of color choices and edging options. Transform the look and feel of your home for a fraction of the cost of a whole kitchen remodel.",
    "Resurface and update your countertops in the kitchen by contacting MrResurface in Wolcott, CT today! Call or text pictures of your countertops to 203-578-5260 and get a free estimate.",
  ],
  video: {
    id: "5MSArvH0C0s",
    title: "Kitchen Countertop Resurfacing by MrResurface LLC.wmv",
  },
  gallery: [
    "banner-1.jpg",
    "banner-3.jpg",
    "078-1024x764.jpg",
    "1511-1024x764.jpg",
    "a-before1.jpg",
    "a-after1.jpg",
    "bathroom-sink-vanity1-300x224.jpg",
    "black-white-vanity-top1-1024x764.jpg",
    "countertop-10.jpg",
    "Black-Stone-Composite-Finish-1024x764.jpg",
    "Blue-Laminate-1024x765.jpg",
    "Contract-Signed-0181-1024x764.jpg",
    "Blue-Laminate2-1024x764.jpg",
    "countertop-1.jpg",
    "countertop-2.jpg",
    "countertop-3.jpg",
    "countertop-8.jpg",
    "countertop-4.jpg",
    "countertop-5.jpg",
    "countertop-6.jpg",
    "countertop-7.jpg",
    "countertop-9.jpg",
    "countertop-11.jpg",
    "countertop-12.jpg",
    "countertop-13.jpg",
    "countertop-14.jpg",
    "countertop-16.jpg",
    "countertop-15.jpg",
    "countertop-17.jpg",
    "countertop-18.jpg",
    "Slate-Stone-Black-Look-1024x764.jpg",
    "workpics-011-1024x764.jpg",
    "workpics-020-1024x764.jpg",
    "Countertop-Showroom-2-1024x680.jpg",
    "Granite-Gloss-Finish.jpg",
    "Custom-Countertop-Edge.jpg",
    "Granite-edge1.jpg",
    "Corian-Black-Granite.jpg",
  ].map((f) => `${M}/${f}`),
};

export const colorChoicesPage = {
  h1: "Countertop Color Choices",
  freehand: [
    `${M}/1624907543794_colors_freehand1.1.jpg`,
    `${M}/colors_freehand2-brightened.jpg`,
  ],
  colors: [
    { name: "Misty Grey", image: `${M}/Misty_grey.png` },
    { name: "Venetian Tan", image: `${M}/Venetian_tan.png` },
    { name: "Fawn", image: `${M}/Fawn.png` },
    { name: "Black Stone", image: `${M}/black_stone.png` },
    { name: "Aztec Brown", image: `${M}/aztec_brown.png` },
    { name: "Stone Wall Grey", image: `${M}/stone_wall_grey.png` },
    { name: "Night Spots", image: `${M}/night_spots.png` },
    { name: "Birch Granite", image: `${M}/birch_granite.png` },
    { name: "Smokey Granite", image: `${M}/smokey_granite.png` },
    { name: "Great Granite", image: `${M}/great_granite.png` },
    { name: "Galaxy", image: `${M}/galaxy.png` },
    { name: "Cliff Rock", image: `${M}/cliff_rock.png` },
    { name: "Astoria Granite", image: `${M}/astoria_granite.png` },
    { name: "Florence Sand", image: `${M}/florence_sand.png` },
    { name: "Latte", image: `${M}/latte.png` },
  ],
};

export const showroomPage = {
  h1: "Showroom",
  subhead: "Bathtub & Kitchen Countertop Resurfacing",
  paragraphs: [
    "Are you the seeing is believing type? If so, you are not alone. When people come to the showroom I hear over and over again, “This is nicer than I thought it would be – the pictures online don't do it justice.” That's what I like to hear!",
    "Would you like to see color choices and some resurfaced laminate-formica countertops in person before you commit to an in-home written estimate? Would you like to see and feel a sample of a cast iron tub that has been reglazed? If so, please schedule an appointment to see the resurfacing showroom at 1776 Meriden Rd. Unit 1B - Rear Building Wolcott, CT 06716.",
    "Since the showroom is only open by appointment, please call 203-578-5260 to arrange your visit. When you come to the showroom, please bring the dimensions of the countertop area you are interested in resurfacing to receive a quote.",
  ],
  secondSubhead: "Resurfacing Showroom",
  secondParagraph:
    "Our showroom is open by appointment and located at 1776 Meriden Rd. Unit 1B - Rear Building Wolcott, CT 06716. Call 203-578-5260 to make an appointment to see tub reglazing and kitchen countertop resurfacing samples.",
  showroomGallery: [
    "Corian-Black-Granite2.jpg",
    "Countertop-Showroom-2-1024x6803.jpg",
    "Granite-Gloss-Finish3.jpg",
    "Tub-before-after53.jpg",
    "Custom-Countertop-Edge3.jpg",
    "Granite-edge13.jpg",
  ].map((f) => `${M}/${f}`),
  beforeAfterTitle: "Before and After",
  beforeAfter: ["1.jpg", "2.jpg", "3.jpg", "4.jpg", "5.jpg"].map((f) => `${M}/${f}`),
};

export const testimonialsPage = {
  h1: "Testimonials",
  intro:
    "Below are eleven detailed letters and reviews from Mr. Resurface customers across Connecticut, reproduced exactly as they were written. Further down this page you will find our complete review wall — every verified review we have collected from Google, Angi, Facebook and the Better Business Bureau, with its original rating, date and source. No membership or sign-up is needed to read any of them.",
  joinUrl: "https://join.angieslist.com/welcome",
  items: [
    {
      author: "Eileen – Watertown CT",
      work: "Refinished the tub and tile surround in our master bathroom.",
      body: "Ernest responded to my service request promptly. I contacted him because I was familiar with the quality of his work from a similar job he did for us nearly 4 years ago. The original bath and shower surround he resurfaced has held up beautifully, so we decided to have the same type of work done in another bathroom. He came when he said he would, the work was completed in the time estimated (approx 5 hours), the price was as quoted, and the job was meticulously done. We now have a beautiful new bathtub for a fraction of the cost of installing an acrylic liner. I would highly recommend his services. I did contact another bath refinisher just to double check his pricing both 4 years ago and before hiring him this time. Ernest's prices were most competitive on both occasions. I would highly recommend his services.",
    },
    {
      author: "Mindy – West Hartford CT",
      work: "Cast Iron bathtub resurfacing",
      body: "Ernest is a man who is honest, dependable and very likable. He has a really nice, easy going personality and you just know he will do right by you. He took the time to educate me on his process and how it differs from other companies. He is very much into the science of his materials. Go see Ernest's showroom (open by appointment). It sells his resurfacing with an impressionable show-n-tell. Ernest prepped the job by tarping my house from foyer up to the 2nd floor bathroom. He made sure to ventilate the premises and cleaned up after his work was complete. Job start, end, and cost were all done as promised. While putting our toiletries back in the tub, we dinged the new shiny-white finish. Ernest was back next day for a quick repair and he's got a great warranty for future incidents.",
    },
    {
      author: "Marianne – Sandy Hook CT",
      work: "Ernest resurfaced a bath tub that had outdated color.",
      body: "I am extremely pleased with the outcome and the work done. Ernest was very helpful with any questions I had in regards to prep work, and promptly returned E-mails even during the weekend. He showed up on time and is very friendly and pleasant to deal with. He is very professional in what he does, and his work is outstanding. We have a couple of more projects coming up, and will definitely use him again. Overall a great experience, and highly recommended. I was blown away by the result.",
    },
    {
      author: "David – Guilford CT",
      work: "Mr Resurface resurfaced a fiberglass tub/shower enclosure for me as I was preparing my condo for sale. Not only did they resurface, they filled divots and nicks so that the unit looked, frankly, better than new.",
      body: "I called them from a newspaper ad. They were prompt, efficient in scheduling and working, and left my home immaculate after doing a beautiful job!! They also left good details about future cleaning and surface maintenance that were very useful. A+ company to do business with!",
    },
    {
      author: "Amy – Glastonbury CT",
      work: "Our bathtub, shower stall and surrounds (circa 1960) needed to be re-grouted and reglazed.",
      body: "Ernest answered our call late in the day on a Saturday. Promptly returned our calls with follow up questions on Sunday. Provided an email confirmation of our appointment, showed up on time, worked like CRAZY all day to finish the bathtub, shower stall and surrounds. He left the work area clean. And the work 48 hours later, is great. Ernest himself was pleasant and professional.",
    },
    {
      author: "Joe & Debbie Penta – Waterbury, CT",
      work: "Countertop Resurfacing",
      body: "“The end results are nothing short of amazing! It looks as if we had a “designer” come in and redo our kitchen at an outrageous price! This is not only economically a wise choice, the finished product is stunning and not to be believed!”",
      beforeAfter: [
        { label: "Before", image: `${M}/Penta-before.jpg` },
        { label: "After", image: `${M}/Penta-After.jpg` },
      ],
    },
    {
      author: "Better Business Bureau – Wallingford, CT",
      work: "Case #: 84077284 — Consumer: Mr. William C. Nadwarski",
      body: "BBB is pleased to inform you about a highly complimentary letter we received from one of your customers. It was refreshing to receive it since about 99% of our correspondence deals with complaints. Thank you for the favorable experience given to this consumer. Sincerely, Carolyn M. Betts, BBB",
    },
    {
      author: "Jerry – West Cornwall, CT",
      work: "Bathtub resurfacing",
      body: "“Ernest resurfaced our bath tub today and it looks fantastic. And to think we were going out to buy a new one. Ernest was an extremely personable and knowledgeable person and an asset to your firm. Great job guys…and gals.”",
    },
    {
      author: "Marcia – Windsor Locks, CT",
      work: "Kitchen countertop resurfacing",
      body: "“Ernest Resurfaced my Kitchen Countertop and my daughter's Countertop down the street and we both love our countertops, they are beautiful, Thank You so much Mrresurface!”",
    },
    {
      author: "Daniel – Thomaston, CT",
      work: "Countertop resurfacing",
      body: "“Ernest, I wanted to thank you again for the Countertop Resurfacing Job you did for us last week. We had some people over for a party last weekend and we got a lot of compliments for your professional Job, thanks again!”",
    },
    {
      author: "Judy & Andy – Manchester, CT",
      work: "Kitchen counter resurfacing",
      body: "“Ernest, We just wanted to tell you how much we love our kitchen counter! Thanks, Judy & Andy”",
    },
  ],
};

export const contactPage = {
  h1: "Email Us Today!",
  subhead:
    "Text a picture of your project to 203-578-5260 for a free estimate on your resurfacing project.",
  paragraphs: [
    "Sending me pictures of your tub and tile is the best way for me to get you a price quote quickly. I usually respond within a day. Kitchen counter pictures should include measurements.",
    "With pictures, please let me know where in Connecticut the job is located and make sure I can see the whole job – for example the top of the tile, if a tile reglazing quote is requested.",
    "If you know that your tub has been coated or reglazed before, please indicate that in your message as I would need to strip off the old finish to reglaze the tub properly for you.",
  ],
  formTitle: "Contact Us Email Form!",
};

export const tubTileFaq = {
  h1: "Tub and Tile Reglazing CT",
  items: [
    {
      q: "Do you need to see my bathtub?",
      a: "If you are having just your bathtub, or your bathtub and the tile over it reglazed, I do not need to look at it to give you an estimate. You can text pictures of your tub to 203-578-5260. To receive an estimate for a standard sized tub please use the estimate form.",
    },
    {
      q: "Is the Price too good to be true?",
      a: "\"You get what you pay for\" is very true with refinishing. A professional refinishing job will save you time and money. A poor refinishing job can cost you extra time and money along with a large dose of frustration. The cost to refinish a standard size 5 foot residential tub can range from $800 to $2000, depending on location and condition of the tub, such as has someone tried to reglaze it before. Before taking the lowest bid, make sure the company is reputable. That's why I'm happy to have over 60 reviews on Angie's List all with an A rating. To avoid headaches, check with reporting companies like Angie's List to see what experiences past customers have had and just don't trust the companies word or the few references they provide you with. Anybody can fabricate references.",
    },
    {
      q: "Can I see samples of the work?",
      a: "If the refinisher has a showroom, go by for a visit and check out samples of the work. If he does not have a showroom, ask if there is somewhere else to see his work. Ask to see a sample of the finish. Any refinisher could post the greatest testimonials on their website, but it's nice to still see for yourself rather than just taking their word on it. So that's why I have a showroom located at 1776 Meriden Rd, Wolcott CT Rear Building that is open by appointment to show people the quality of my work.",
    },
    {
      q: "Is the Bathtub Refinisher Local?",
      a: "I'm a locally owned non-franchise company. I am based in Wolcott / Waterbury, CT which is within a 40 minute drive from most of the state of Connecticut. I have access to 3 major highways, I-84, I-91 and Route 8, and can reach the Counties of Hartford, New Haven, Fairfield, Middlesex, Litchfield, Tolland within 40 minutes. A local refinisher is more apt to take care of you should your job need service down the road, whether it is covered by the warranty or not.",
    },
    {
      q: "How Long Has MrResurface Been Refinishing Bathtubs?",
      a: "I have been refinishing bathtubs and countertops since 1996. If you can't find this information on my competitors website, it's because they don't want you to know. Be wary of franchises. Just because the franchise has been around for 30 years or so does not mean the franchisee owner is trained or experienced. Training a few days at a facility is not the same as on the job training. Since I'm not a franchise, all my years of training has come on the job.",
    },
    {
      q: "Can I just use a tub refinishing kit and refinish my own tub?",
      a: "Yes, but it will not look nice nor will it last. Unfortunately the do-it-yourself tub refinishing kits sold online or at Home Depot or Lowes do not provide the proper adhesion preparation components to prevent the inferior epoxy finish from peeling off the tub within days. Since the kits use a roller to apply the finish, the tub will have roller streaks no matter how much the kit's instructions say it will level after applying it. The worst part is that to have the tub reglazed professionally will cost 60% more than if the tub was reglazed professionally the first time as the epoxy finish needs to be stripped off for the tub to be reglazed properly.",
    },
    {
      q: "Can you change the color of my tub & tile?",
      a: "Yes! We can change from whatever color you have, to any color. We carry all manufacturer colors, so we can match your old tub and tile to a new fixture.",
    },
    {
      q: "Does my drain have to be removed?",
      a: "No. Usually by the time you're ready to refinish your bathtub, your drain has been in place for many years. So removing it and replacing it can be quite a job and may cause other damage. So unless you want to have a new drain, we recommend leaving it in, but if you are going to change the drain, you would want to do it before your tub is reglazed.",
    },
    {
      q: "How long before I can use the new finish?",
      a: "You can recaulk and use your tub 24 hours after we finish reglazing it.",
    },
    {
      q: "What if my tub was refinished before?",
      a: "We can still refinish your tub. To guarantee our work, we must remove the old finish before applying the new one. This does require additional time and labor, so there is an extra prep charge. Of course, as with any refinishing, proper prep is very important to a successful and lasting refinishing job.",
    },
    {
      q: "What if I Have Shower Doors?",
      a: "If you have shower doors you have three options when it comes to bathtub refinishing. If you plan to keep the same shower doors, we just need you to take the doors off of the shower track and we can mask off the shower track that you will leave on the tub. You will re-install the same shower doors after the refinished tub has cured. You can also remove the shower track and doors completely if you want to convert to a shower curtain or a new shower door before we reglaze your tub.",
    },
    {
      q: "How does Bathtub Refinishing compare with a bathtub liner?",
      a: "The finish we apply to your tub is much harder than that of a bathtub liner or insert. Also, our finish is bonded directly to your tub, there are no air pockets such as is the case with a bathtub liner. Thus, no moisture can develop which in turn will lead to mold and mildew growing between the bathtub liner and your tub. This can cause a very annoying odor. Reglazing your tub is also much less expensive than having a bathtub liner installed.",
    },
    {
      q: "Can you fix a crack in my fiberglass tub?",
      a: "Yes, we repair cracks in fiberglass tubs. If the crack is in the bottom of your tub, we can install a patented, specially designed inlay. The inlay will seal the crack and add support to the floor of your bathtub, and we are one of the few companies in Connecticut using this method and technology. We also perform other repair and refurbishing related services on tile, porcelain, and cast-iron tubs, sinks, and kitchen/bathroom surfaces.",
    },
    {
      q: "How long will the reglazed surface last and is it guaranteed?",
      a: "A reglazed tub that is cared for properly, will last 15 plus years. We will provide you with guidelines on proper care and maintenance. MrResurface LLC of Connecticut offers a 5 year, written no-fault warranty on reglazed tubs. After 30 days of completion of service, there is a small service fee to repair any damage to tubs, regardless of reason.",
    },
    {
      q: "What should I use to clean the new finish?",
      a: "We recommend using a non-abrasive cleaner, such as Lysol Tub & Tile Cleaner (without bleach) or Fantastik (without bleach). How you maintain your tub is the most important way to get the 15 plus year life out of your newly reglazed tub. Since the new finish has a very high gloss surface, there is no need to use abrasive cleaners, and in fact, abrasives or the wrong cleaner can be detrimental to your new surface. Always use a soft sponge or towel when cleaning the tub, and never use a scouring pad or something similar as this would scratch and wear away the finish over time and compromise the finish. Any other cleaners may void the warranty. Note: DO NOT clean your reglazed bathtub with Paint Thinner, Goof OFF®, Scrubbing Bubbles®, Acetone, Lacquer Thinner, M.E.K.® or other chemicals that attack the structural integrity of plastics (which includes acrylic urethanes which the reglazed tub is made of). Use of these chemicals will destroy the acrylic surface of your bathtub and there is no way to reverse the damage caused by this type of chemical reaction. Use of these chemicals will void your warranty.",
    },
    {
      q: "I've received quotes from a couple hundred to a thousand dollars to reglaze a tub, is there a difference in quality?",
      a: "Yes. There are shortcuts that can be taken to keep the price down that the customer would not be aware of until it's too late, such as using inferior materials or spraying over an old reglazing job and not stripping it and doing the job right. The difference between me and my competition is professionalism. I use the most durable material available to a professional reglazer which is an expensive 24-HOUR CURE HIGH SOLIDS ACRYLIC URETHANE COATING. This material is only sold to trained professional refinishers and it's not an inexpensive 1-step epoxy finish which the lowest bid companies are using. This material is not sold from a hardware store. Not everyone uses the same materials. If a company is offering a 2-3 year warranty, chances are they are using inferior materials. Asking for references is good, but companies will only give you favorable references, so you should check things they don't have control over such as their license status with the Department of Consumer Protection. All tubs by MrResurface are done by Ernest Staton Jr since 1996, so you get the same A+ certified quality every time. A small state based company will usually have more experienced technicians than a large multi-state franchise company. If you are told that the finish will take longer than 24 hours to cure, then the company is using an old epoxy curing formula. I, Ernest Staton Jr, will service your tub reglazed by MrResurface even if the damage is not covered by the warranty — I have just charged a modest repair fee ($55-$75) to bring the tub back to like new condition. This policy has won me more than a few referrals.",
    },
  ],
};

export const countertopsFaq = {
  h1: "Kitchen Countertop Resurfacing FAQ",
  items: [
    {
      q: "What is Kitchen Countertop Resurfacing?",
      a: "First, kitchen countertop resurfacing is not a simple do it your-self paint job that some have attempted over their own countertops. Professional kitchen countertop resurfacing is the application of man-made composite polymers that are applied right over your existing laminate/formica countertops eliminating the need to demolish your kitchen. The finished product is a durable scratch, stain, and burn resistant countertop. If you like the current layout of your kitchen and are happy with your cabinets, but just don't like that your countertops look like laminate, then countertop resurfacing is a viable option. To see this amazing finish, please call to schedule an appointment to see the showroom.",
    },
    {
      q: "Are there any seams in the new surface?",
      a: "No. All the old seams will be sealed under the new surface. You will have a solid surface finish. That's just one of the advantages this surface has over new laminate tops.",
    },
    {
      q: "Does my sink have to be removed?",
      a: "No, we do all the resurfacing without having to remove the sink. This in itself can save you the cost of hiring a plumber and any repairs due to damage that may occur when old plumbing is unhooked.",
    },
    {
      q: "How Do You Change the Corners?",
      a: "We use a machine that cuts a styled edge into the existing countertop. We then apply our new surface over it. You can have edges that are not even available with brand new laminate counters. This feature really sets off the new surface, giving it a very modern look.",
    },
    {
      q: "How long before I can use the countertop?",
      a: "You can start using the counter 2 days after we resurface it.",
    },
    {
      q: "How tough is the new surface?",
      a: "Our new countertop surfaces use the latest in eco-friendly, polymer technology to deliver a new finish that gets as hard as glass. It is scratch resistant, and non-porous so it does not stain like traditional stone surfaces. There is no need to reseal the countertop on an ongoing basis.",
    },
    {
      q: "How long do you guarantee the new surface?",
      a: "We give you 5 years warranty coverage on your new countertop surface. We cannot guarantee against scratching or other misuse, which is the standard practice with all new countertop surfacing.",
    },
    {
      q: "If I damage the new surface, can it be repaired?",
      a: "A distinct advantage of refinished kitchen countertops is that the new surface, by its design, is quickly reparable by a qualified refinisher. These minor repair jobs are generally very economical, especially when compared to the costs of making repairs (if possible!) to marble and stone countertops. The stone and marble countertops often aren't even reparable and require full replacement.",
    },
    {
      q: "What do you do with the backsplash?",
      a: 'There are two kinds of backsplashes, we can resurface both kinds. If you have the short 4" backsplash that would be included with the normal countertop resurfacing. If you have a backsplash that goes all the way to the bottom of the wall cabinets you can have us resurface it, or some have had us resurface just the counter and then have installed tile over the backsplash, which can give you a very modern look.',
    },
    {
      q: "What if I set something hot on the surface?",
      a: "After fully cured, this surface is very heat resistant. It can take up to 600 degree heat, but you still should be careful. Extreme heat can damage any countertop except for stainless steel countertops.",
    },
    {
      q: "Why and what should I consider before resurfacing my kitchen countertops instead of replacing them?",
      a: "Kitchen countertop replacement is a hefty project in any home which is why it's best to consider all available options before you undertake such a big venture. Consider that you won't have access to your kitchen for several days – even weeks. Research the advantages and disadvantages associated with various materials used in the construction of countertops, including maintenance issues, whether your chosen surface is liable to stain, dull or chip, etc. Most often tile, granite, or solid surfaces of different natural materials are used as well as solid surface composites such as Corian®, engineered stone like Silestone® and Swanstone, or laminates like Formica®. Compare the look, the cost and color you select together with the time and mess that's involved in installing it and maintaining it. Remember that replacement is almost always more expensive than resurfacing. If you are changing your kitchen or bathroom floor, replacement may be the best option for you. However, if you don't plan to change your cabinets as well, refinishing might just be the most affordable, attractive and ideal option for you. With resurfacing, you're looking at cost savings upwards of 60% as compared to replacement. In many cases, after resurfacing, you can use your kitchen again within 2 days.",
    },
    {
      q: "Is granite the best countertop option for your home?",
      a: "Looking to remodel your kitchen with granite? This is the best option for you if you are looking for a beautiful, long-lasting product which will adorn your kitchen and bring in a feeling of warmth to your home for years — but only if you're willing to give it some tender loving care every six months or so. Granite countertops can be very expensive: they often also require new cabinetry in order to complete a full kitchen remodeling project. Slabs must be precisely matched and cut and need regular maintenance every half a year. Granite Pros: very durable and resistant to cuts and scratches; completely heat resistant; each piece has its own unique natural stone pattern. Granite Cons: porous which can cause bacteria to form requiring regular sealing; it is expensive; the seams between slabs can be hard to match.",
    },
    {
      q: "What is an affordable alternative to Granite Countertops?",
      a: "MrResurface offers custom kitchen countertop resurfacing with many unique stone patterns and custom edging options to choose from that will give you the look of natural stone without the high cost and maintenance of granite. Many of our customers have said that they like the beauty and ease of care of their resurfaced countertops better than their friends and families more expensive granite countertops, and they have expressed how grateful they are that they saved thousands of dollars that they can use in other areas of their home or livelihood.",
    },
  ],
};

export const billingPage = {
  h1: "Billing",
  sections: [
    {
      heading: "Terms and Conditions",
      body: "By Clicking the Payment Button you are agreeing to pay the agreed upon amount from the work that will be provided.",
    },
    {
      heading: "The Information We Collect",
      body: "Mr Resurface may collect nonpublic personal information from User in a variety of ways, including online forms for ordering products and services, and other instances where Users are invited to volunteer such information. The type of information we collect from consumers includes, but is not limited to: First Name, Last Name, Street Address, City, State, Zip Code, Phone number, and Email Address. Mr Resurface may also collect information about how Users use our Web site, for example, by tracking the number of unique views received by the pages of the Web site or the domains from which Users originate. We may use \"cookies\" to track how Users use our Web site. A cookie is a piece of software that a Web server can store on the Users' PC and use to identify the Users should they visit the Web site again. While not all of the information that we collect from Users is nonpublic personal information, it may be associated with nonpublic personal information that Users provide us through our Web site.",
    },
    {
      heading: "Third party links",
      body: "Occasionally, at our discretion, we may include or offer third party products or services on our website. These third party sites have separate and independent privacy policies. We therefore have no responsibility or liability for the content and activities of these linked sites. Nonetheless, we seek to protect the integrity of our site and welcome any feedback about these sites.",
    },
    {
      heading: "Use of IP Addresses",
      body: "An IP (Internet Protocol) address is a number that is assigned to your computer when you use the Internet. Your IP address does not contain any nonpublic personal information about you. Mr Resurface collects IP addresses for the purposes of system administration, to report aggregate information to our advertisers, and to ensure the validity of customer requests.",
    },
    {
      heading: "Unsubscribe",
      body: "If you would like to unsubscribe and opt out, please send email to mrresurface@gmail.com.",
    },
    {
      heading: "Our Privacy Policy",
      body: "1. It is our policy at Mr Resurface to make sure that all our work has been completed to the best of our ability. Each refinished job should be maintained per instructions left with the customer on the invoice. Deposits are not refundable as these funds are used to purchase materials for your job. 2. Mr Resurface accepts cash, credit cards (Visa, Mastercard, American Express and Discover) as well as checks ($30 returned check fee). All Mr Resurface jobs completed that are made within Connecticut are subject to Connecticut State sales tax.",
    },
  ],
};
